import { Loader2 } from 'lucide-react'

export function FullPageLoader({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex min-h-dvh items-center justify-center" role="status" aria-live="polite">
      <Loader2 className="text-muted-foreground size-6 animate-spin" aria-hidden />
      <span className="sr-only">{label}</span>
    </div>
  )
}

/** Inline variant for suspended route content inside the app shell. */
export function SectionLoader({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex min-h-64 items-center justify-center" role="status" aria-live="polite">
      <Loader2 className="text-muted-foreground size-5 animate-spin" aria-hidden />
      <span className="sr-only">{label}</span>
    </div>
  )
}
